import axios from 'axios';
import { getCaptchaToken } from './recaptcha';
export async function validateEmail(email = '') {
    try {
        if (!email) {
            return false;
        }

        const captchaToken = await getCaptchaToken('validate');
        const response = await axios.post('user/validate-email', { email: email, captcha_token: captchaToken });
        const statusCode = response.status;
        if (statusCode !== 200) {
            return false;
        }

        return true;
    } catch (error) {
        console.error(error.message ? error.message : 'Error while trying to validate email');
        return false;
    }
}